export default {
  SEARCH: 'Search',
  ANY_CATEGORY: 'Any Category',
  SINGLE_CHOICE: '(Single choice)',
  ASIN_LIST: 'Product List',
  SEARCH_NOT_FOUND: 'Search results are empty  try other keywords',
  NO_MATCH_ASIN: 'No matching products  try other options',
  REQUEST_FAILED_RELOAD: 'Request Failed, Click to Refresh',
  NO_MORE: 'No more'
};
